import { render, staticRenderFns } from "./CodigoPreventa.vue?vue&type=template&id=54a61776"
import script from "./CodigoPreventa.vue?vue&type=script&setup=true&lang=js"
export * from "./CodigoPreventa.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports